import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { Organisation } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetUsersOrganisation = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Organisation>([QueryEntity.Organisation], async () => {
    try {
      const res = await fetch(`${APIBaseChronos}/api/org`, fetchConfigGET);
      return await res.json();
    } catch (err) {
      console.error(err);
    }
  });
};
